import { graphql, StaticQuery } from "gatsby";
import React, { useState } from "react";
import Layout from "../components/layout";

const query = graphql`
  query SiteTitleQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      displaySiteTitle
      _rawFooterTextFirst(resolveReferences: { maxDepth: 5 })
      _rawFooterTextSecond(resolveReferences: { maxDepth: 5 })
      _rawFooterTextThird(resolveReferences: { maxDepth: 5 })
      logo {
        asset {
          url
        }
      }
    }
  }
`;

function LayoutContainer(props) {
  const [showNav, setShowNav] = useState(false);
  function handleShowNav() {
    setShowNav(true);
  }
  function handleHideNav() {
    setShowNav(false);
  }

  return (
    <StaticQuery
      query={query}
      render={(data) => {
        if (!data.site) {
          throw new Error(
            'Layout.js - Missing "Site settings". Open the Studio at http://localhost:3333 and some content in "Site settings"'
          );
        }
        return (
          <Layout
            {...props}
            showNav={showNav}
            onHideNav={handleHideNav}
            onShowNav={handleShowNav}
            siteTitle={data.site.title}
            siteLogo={data.site && data.site.logo && data.site.logo.asset && data.site.logo.asset.url}
            displaySiteTitle={data.site.displaySiteTitle}
            siteFooterTextFirst={data.site._rawFooterTextFirst}
            siteFooterTextSecond={data.site._rawFooterTextSecond}
            siteFooterTextThird={data.site._rawFooterTextThird}
          />
        );
      }}
    />
  );
}

export default LayoutContainer;